import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { GET_STARTED_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { cn } from '../../src/lib/utils';

/** Bottom CTA on small screens, revealed after the hero scrolls away. */
export function MobileStickyCta({
  placement = 'mobile_sticky'
}: {
  placement?: string;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={cn('fixed inset-x-0 bottom-0 z-30 border-t border-hairline bg-ink/90 px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur-xl transition-[transform,visibility] duration-300 motion-reduce:transition-none sm:hidden', visible ? 'visible translate-y-0' : 'invisible translate-y-full')} data-id="element-133" data-mp="730g2u7eo58d">
      <CtaButton href={GET_STARTED_URL} event="primary_cta_click" eventParams={{
      placement,
      cta: 'get_started'
    }} size="lg" className="w-full" data-id="element-134" data-mp="1c9l5ixy6xp6s">
        Get Started
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-135" data-mp="1m3bmlhrzmxcg" />
      </CtaButton>
    </div>;
}